"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.removeLanguageFromRelativeUrl = void 0;
const REGEX_FOR_LANGUAGE_CODE = /^\/[a-z]{2}(\/|$)/i;

/**
 * Remove language code from url
 * /kz/products => /products
 * /kz => /
 *
 * @param url
 */
const removeLanguageFromRelativeUrl = url => url && REGEX_FOR_LANGUAGE_CODE.test(url) ? url.replace(REGEX_FOR_LANGUAGE_CODE, '/') : url ?? '/';
exports.removeLanguageFromRelativeUrl = removeLanguageFromRelativeUrl;
